import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { ArrowLeft, Loader2, Save } from 'lucide-react';
import DatosProducto from './DatosProducto';
import OpcionesPersonalizacion from './OpcionesPersonalizacion';
import InterruptorVisible from './InterruptorVisible';
import { adminApi, errorApi, errorProducto } from './tiendaAdminApi';

const VACIO = { nombre: '', descripcion: '', etiqueta: '', precio: '', precio_nota: 'IVA incluido', imagen_url: null, grupos: [] };

export default function EditorProducto({ productoId, onCerrar, onCreado }) {
  const esNuevo = productoId === 'nuevo';
  const [producto, setProducto] = useState(esNuevo ? VACIO : null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (esNuevo) return;
    adminApi.producto(productoId).then(r => setProducto(r.data)).catch(e => { toast.error(errorApi(e, 'Producto no encontrado')); onCerrar(); });
  }, [productoId, esNuevo, onCerrar]);

  if (!producto) return <div className="h-64 animate-pulse rounded-xl bg-slate-200" />;

  const set = (campo, valor) => setProducto(p => ({ ...p, [campo]: valor }));

  const guardar = async () => {
    const error = errorProducto(producto);
    if (error) { toast.error(error); return; }
    setGuardando(true);
    try {
      const datos = { ...producto, precio: Number(producto.precio) };
      const r = esNuevo ? await adminApi.crear(datos) : await adminApi.guardar(producto.id, datos);
      setProducto(r.data);
      toast.success(esNuevo ? 'Producto creado (oculto para los clientes)' : 'Cambios guardados');
      if (esNuevo) onCreado(r.data.id);
    } catch (e) {
      toast.error(errorApi(e, 'No se pudieron guardar los cambios'));
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="space-y-5 pb-24" data-testid="tienda-editor-producto">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <button onClick={onCerrar} className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900" data-testid="tienda-editor-volver">
          <ArrowLeft className="h-4 w-4" />Volver a productos
        </button>
        {!esNuevo && <div className="w-full sm:w-auto"><InterruptorVisible producto={producto} onCambio={p => set('visible_clientes', p.visible_clientes)} /></div>}
      </div>
      <DatosProducto producto={producto} set={set} />
      <OpcionesPersonalizacion grupos={producto.grupos} setGrupos={g => set('grupos', g)} />
      <div className="fixed inset-x-0 bottom-0 z-20 border-t border-slate-200 bg-white/95 px-4 py-3 backdrop-blur">
        <div className="mx-auto flex max-w-6xl justify-end">
          <button onClick={guardar} disabled={guardando} className="inline-flex items-center gap-2 rounded-lg bg-emerald-700 px-5 py-2.5 font-semibold text-white transition hover:bg-emerald-800 disabled:opacity-60" data-testid="tienda-guardar-producto">
            {guardando ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}{esNuevo ? 'Crear producto' : 'Guardar cambios'}
          </button>
        </div>
      </div>
    </div>
  );
}
